const MedicalFillInFormUtils = {
  hasValidComment(comment) {
    return (
      comment && comment !== "" && comment !== " " && comment !== "\n" && comment !== undefined
    );
  },
  isInSeries(num) {
    const min = 6;
    const max = 210;
    const validLastDigits = [6, 7, 8, 9, 10];

    return num >= min && num <= max && validLastDigits.includes(num % 10);
  },
  badgeStyle(comment) {
    return `
      z-index: 8;
      position: absolute;
      top: -4px;
      right: -4px;
      height: 12px;
      width: 12px;
      background: ${comment ? "#ff2600c8" : "#cbcbcbc7"};
      color: ${comment ? "#fff" : "#000"};
      border-radius: 50%;
      font-size: ${comment ? "11px" : "10px"};
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 10px;
    `;
  },
  isQuestionAnswered(question) {
    if (!question) return false;

    if (question.options && Array.isArray(question.options)) {
      return question.options.some((option) => option.selected);
    }

    if (question.answer !== undefined && question.answer !== null && question.answer !== "") {
      return true;
    }

    return !!(question.answerFile || question.answerPhoto?.url);
  },
  validateRequiredQuestions(questions) {
    if (!questions || !Array.isArray(questions)) return [];

    return questions.filter((question) => {
      return question.required && !this.isQuestionAnswered(question);
    });
  },
};

export default MedicalFillInFormUtils;
